import React from "react";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { addFile, postServices } from "../../services/Admin/adminServices";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";



import LocationAdd from "../components/LocationAdd";
const initialValues = {
  title: "",
  email: "",
  countryCodes: "",
  phoneNumber: "",
  description: [
    {
      question: "",
      answer: "",
    },
  ],
  shortDescription: "",
  logo: "",
  banner: "",
  address: {
    name: "",
    city: "",
    state: "",
    streetAddress: "",
    pincode: "",
    location: {
      type: "Point",
      coordinates: [0, 0],
    },
  },
  accessSupport: [
    {
      office: "",
      name: "",
      phoneNumber: [
        { title: "Primary", number: "" },
        { title: "Emergency", number: "" },
      ],
      email: [""],
      post: "",
      location: {
        name: "",
        city: "",
        state: "",
        streetAddress: "",
        pincode: "",
        location: {
          type: "Point",
          coordinates: [0, 0],
        },
      },
    },
  ],
  faq: [{
    question: "",
    answer: ""
  }]
};



const validationSchema = Yup.object({
  title: Yup.string()
    .trim()
    .required("Title is required")
    .min(3, "Title must be at least 3 characters"),

  email: Yup.string()
    .email("Invalid email format")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Email must be a valid format"
    )
    .required("Email is required"),

  countryCodes: Yup.string()
    .required("Country code is required"),

  phoneNumber: Yup.string()
    .matches(/^[0-9]{7,15}$/, "Phone number must be 7-15 digits")
    .required("Phone number is required"),

  description: Yup.array().of(
    Yup.object({
      question: Yup.string().required("Question is required"),
      answer: Yup.string().required("Answer is required"),
    })
  ),

  shortDescription: Yup.string()
    .required("Short description is required")
    .test(
      "maxWords",
      "Short description cannot exceed 200 words",
      (value) => {
        if (!value) return true;
        const count = value.trim().split(/\s+/).filter(Boolean).length;
        return count <= 200;
      }
    ),

  banner: Yup.string()
    .required("Banner image is required"),

  address: Yup.object({
    name: Yup.string().required("Name is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    streetAddress: Yup.string().required("Street address is required"),
    pincode: Yup.string()

      .required("Pincode is required"),
    location: Yup.object({
      type: Yup.string()
        .oneOf(["Point"], "Location type must be 'Point'")
        .required("Location type is required"),
      coordinates: Yup.array()
        .of(Yup.number().required("Coordinate value is required"))
        .length(2, "Coordinates must have exactly 2 values"),
    }),
  }),

  accessSupport: Yup.array().of(
    Yup.object({
      office: Yup.string().required("Office is required"),
      name: Yup.string().required("Name is required"),
      phoneNumber: Yup.array().of(
        Yup.object({
          title: Yup.string().required("Phone title is required"),
          number: Yup.string().required("Phone number is required")
        })
      ),
      email: Yup.array()
        .of(
          Yup.string()
            .email("Invalid email format")
            .matches(
              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
              "Email must be a valid format"
            )
            .required("Email is required") // ✅ add required for each email
        )
        .min(1, "At least one email is required"),
      post: Yup.string().required("Post is required"),
      location: Yup.object({
        name: Yup.string().required("Location name is required"),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        streetAddress: Yup.string().required("Street address is required"),
        pincode: Yup.string()

          .required("Pincode is required"),
      }),
    })
  ),

  faq: Yup.array().of(
    Yup.object({
      question: Yup.string().required("Question is required"),
      answer: Yup.string().required("Answer is required"),
    })
  )

});

const FormComponent = () => {
  const navigate = useNavigate();

  const [previewFile, setPreviewFile] = React.useState(null);
  const [previewBanner, setPreviewBanner] = React.useState(null);
  const [uploadingLogo, setUploadingLogo] = React.useState(false);
  const [uploadingBanner, setUploadingBanner] = React.useState(false);

  return (
    <div className="  text-black   ">

      <h3 className="mb-3" style={{ color: "#0AB7EA" }}>Add Services</h3>
      <Formik initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => { // <-- destructure here
          try {
            console.error("values", values)
            await postServices(values);
            resetForm();
            navigate("/services");
            toast.success("service added");
          } catch (error) {
            toast.error(error?.response?.data.message || "Failed to add service");
            console.error("error", error);
          } finally {
            setSubmitting(false);
          }
        }}>
        {({ values, setFieldValue, isSubmitting }) => (
          <Form>
            {/* Title */}
            <div className="mb-3">
              <label className="form-label">Title</label>
              <Field name="title" className="form-control" style={{ borderColor: "#0AB7EA" }} />
              <ErrorMessage name="title" component="div" className="text-danger" />
            </div>

            {/* Email */}
            <div className="mb-3">
              <label className="form-label">Email</label>
              <Field name="email" type="email" className="form-control" style={{ borderColor: "#0AB7EA" }} />
              <ErrorMessage name="email" component="div" className="text-danger" />
            </div>

            {/* Phone */}
            <div className="mb-3">
              <label className="form-label">Phone Number</label>

              <PhoneInput
                country={"us"}
                onChange={(value, country) => {

                  setFieldValue("countryCodes", "+" + country.dialCode);


                  let dialCode = country.dialCode;
                  let onlyNumber = value.startsWith(dialCode)
                    ? value.slice(dialCode.length)
                    : value;

                  onlyNumber = onlyNumber.replace(/^0+/, "");
                  setFieldValue("phoneNumber", onlyNumber);
                }}
                inputClass="form-control w-100 w-md-50 phoneInp"
                style={{ borderColor: "#0AB7EA" }}
              />
              <ErrorMessage name="phoneNumber" component="div" className="text-danger" />
            </div>

            {/* Upload Logo */}
            <div className="mb-3">
              <label className="form-label">Logo</label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                style={{ borderColor: "#0AB7EA" }}
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  const formData = new FormData();
                  formData.append("files", file);

                  try {
                    setUploadingLogo(true);
                    const res = await addFile(formData);
                    setUploadingLogo(false);

                    setPreviewFile(URL.createObjectURL(file));
                    setFieldValue("logo", res?.data?.data?.files[0].path);
                  } catch (error) {
                    setUploadingLogo(false);
                    toast.error("File upload failed!");
                  }
                }}
              />

              {/* Preview + remove */}
              {previewFile && (
                <div className="mt-3 position-relative" style={{ width: "180px" }}>
                  <img
                    src={previewFile}
                    alt="Preview"
                    className="img-fluid rounded shadow"
                    style={{ maxHeight: "160px", objectFit: "cover" }}
                  />
                  <button
                    type="button"
                    className="btn btn-danger btn-sm position-absolute"
                    style={{ top: "-10px", right: "-10px", borderRadius: "50%" }}
                    onClick={() => {
                      setPreviewFile(null);
                      setFieldValue("logo", "");
                    }}
                  >
                    X
                  </button>
                </div>
              )}

              {uploadingLogo && (
                <div className="text-primary mt-2 fw-semibold">
                  Uploading logo...
                </div>
              )}
            </div>

            {/* Short Description */}
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <label className="form-label mb-0">Short Description</label>
                <span
                  className={`small ${
                    ((values.shortDescription || "").trim().split(/\s+/).filter(Boolean).length > 200)
                      ? "text-danger fw-bold"
                      : "text-muted"
                  }`}
                >
                  {(values.shortDescription || "").trim().split(/\s+/).filter(Boolean).length} / 200 words
                </span>
              </div>
              <Field
                name="shortDescription"
                as="textarea"
                rows={2}
                className="form-control"
                style={{ borderColor: "#0AB7EA" }}
                placeholder="Enter concise summary (max 200 words)..."
              />
              <ErrorMessage name="shortDescription" component="div" className="text-danger mt-1" />
            </div>

            {/* Upload Banner */}
            <div className="mb-3">
              <label className="form-label">Banner Image</label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                style={{ borderColor: "#0AB7EA" }}
                onChange={async (e) => {
                  const file = e.target.files[0];
                  if (!file) return;

                  const formData = new FormData();
                  formData.append("files", file);

                  try {
                    setUploadingBanner(true);
                    const res = await addFile(formData);
                    setUploadingBanner(false);

                    setPreviewBanner(URL.createObjectURL(file));
                    setFieldValue("banner", res?.data?.data?.files[0].path);
                  } catch (error) {
                    setUploadingBanner(false);
                    toast.error("Banner upload failed!");
                  }
                }}
              />

              {/* Preview Banner */}
              {previewBanner && (
                <div className="mt-3 position-relative" style={{ width: "240px" }}>
                  <img
                    src={previewBanner}
                    alt="Banner Preview"
                    className="img-fluid rounded shadow"
                    style={{ maxHeight: "140px", width: "100%", objectFit: "cover" }}
                  />
                  <button
                    type="button"
                    className="btn btn-danger btn-sm position-absolute"
                    style={{ top: "-10px", right: "-10px", borderRadius: "50%" }}
                    onClick={() => {
                      setPreviewBanner(null);
                      setFieldValue("banner", "");
                    }}
                  >
                    X
                  </button>
                </div>
              )}

              {uploadingBanner && (
                <div className="text-primary mt-2 fw-semibold">
                  Uploading banner image...
                </div>
              )}
            </div>



            {/* Address */}
            <h5 className="mt-4">Address</h5>

            <div className="mb-3" >
              <label className="form-label">Office Name</label>
              <Field
                name={`address.name`}
                className="form-control"
                style={{ borderColor: "#0AB7EA" }}
              />
              <ErrorMessage
                name={`address.name`}
                component="div"
                className="text-danger mt-1"
              />
            </div>



            <div className="mb-3">
              <label className="form-label">Street  </label>
              <Field name="address.streetAddress">
                {({ form }) => (
                  <LocationAdd
                    onSelect={(location) => {



                      form.setFieldValue("address.city", location.city || "");
                      form.setFieldValue("address.state", location.state || "");
                      form.setFieldValue("address.streetAddress", location.name || "");
                      form.setFieldValue("address.pincode", location.pincode || "");
                      form.setFieldValue("address.location.type", location.location.type || "");
                      form.setFieldValue("address.location.coordinates[0]", location.location.coordinates[0] || "");
                      form.setFieldValue("address.location.coordinates[1]", location.location.coordinates[1] || "");
                    }}
                  />
                )}
              </Field>
            </div>

            {[


              { key: "city", label: "City" },
              { key: "pincode", label: "Pincode" },
              { key: "state", label: "State" },
            ].map((field) => (
              <div className="mb-3" key={field.key}>
                <label className="form-label">{field.label}</label>
                <Field
                  name={`address.${field.key}`}
                  className="form-control"
                  style={{ borderColor: "#0AB7EA" }}
                />
                <ErrorMessage
                  name={`address.${field.key}`}
                  component="div"
                  className="text-danger mt-1"
                />
              </div>
            )
            )}




            {/* Coordinates */}
            {/* <div className="mb-3">
              <label className="form-label">Coordinates (Lng, Lat)</label>
              <div className="d-flex gap-2">
                <Field
                  name="address.location.coordinates[0]"
                  className="form-control"
                   style={{ borderColor: "#0AB7EA" }}
                />
                <Field
                  name="address.location.coordinates[1]"
                  className="form-control"
                   style={{ borderColor: "#0AB7EA" }}
                />
              </div>
            </div> */}






            {/* Description */}
            <FieldArray name="description">
              {({ push, remove }) => (
                <div className="mt-4 mb-3">
                  <h5 style={{ color: "#0AB7EA" }}>Description</h5>
                  {values.description && values.description.length > 0
                    ? values.description.map((item, index) => (
                        <div key={index} className="border rounded p-3 mb-3 bg-light">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6>Description Item #{index + 1}</h6>
                            {values.description.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => remove(index)}
                              >
                                Remove
                              </button>
                            )}
                          </div>

                          <div className="mb-2">
                            <label className="form-label">Question</label>
                            <Field
                              name={`description.${index}.question`}
                              className="form-control"
                              style={{ borderColor: "#0AB7EA" }}
                              placeholder="e.g. What is this service?"
                            />
                            <ErrorMessage
                              name={`description.${index}.question`}
                              component="div"
                              className="text-danger"
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label">Answer</label>
                            <Field
                              as="textarea"
                              name={`description.${index}.answer`}
                              className="form-control"
                              style={{ borderColor: "#0AB7EA" }}
                              rows={3}
                              placeholder="e.g. Free legal aid for community members"
                            />
                            <ErrorMessage
                              name={`description.${index}.answer`}
                              component="div"
                              className="text-danger"
                            />
                          </div>
                        </div>
                      ))
                    : null}

                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => push({ question: "", answer: "" })}
                  >
                    + Add Description Item
                  </button>
                </div>
              )}
            </FieldArray>



            {/* Access Support */}
            <FieldArray name="accessSupport">
              {({ push, remove }) => (
                <div>
                  <h5 className="mt-4">Access Support</h5>
                  {values.accessSupport.map((support, index) => (
                    <div
                      key={index}
                      className="border rounded p-3 mb-3 bg-light"
                    >


                      <div className="d-flex justify-content-between">
                        <h6>Support #{index + 1}</h6>
                        {values.accessSupport.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => remove(index)}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Office</label>
                        <Field
                          name={`accessSupport.${index}.office`}
                          className="form-control"
                          style={{ borderColor: "#0AB7EA" }}

                        />
                        <ErrorMessage
                          name={`accessSupport[${index}].office`}
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Name</label>
                        <Field
                          name={`accessSupport.${index}.name`}
                          className="form-control"
                          style={{ borderColor: "#0AB7EA" }}
                        />
                        <ErrorMessage
                          name={`accessSupport[${index}].name`}
                          component="div"
                          className="text-danger"
                        />
                      </div>
                      <div className="mb-2">
                        <label className="form-label">Post</label>
                        <Field
                          name={`accessSupport.${index}.post`}
                          className="form-control"
                          style={{ borderColor: "#0AB7EA" }}
                        />
                        <ErrorMessage
                          name={`accessSupport[${index}].post`}
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      {/* Phone Numbers (Fixed: Primary & Emergency) */}
                      <div className="mb-3">
                        <label className="form-label">Phone Numbers</label>
                        {support.phoneNumber.map((ph, phIndex) => (
                          <div key={phIndex} className="d-flex flex-column flex-md-row gap-2 mb-2 align-items-md-center">
                            {/* Title (Readonly) */}
                            <div className="mb-3 ">
                              <Field
                                name={`accessSupport.${index}.phoneNumber.${phIndex}.title`}
                                className="form-control"
                                disabled
                                style={{ borderColor: "#0AB7EA" }}
                              />
                            </div>

                            {/* Country Code Select */}

                            <div className=" mb-3  position-relative  w-100">

                              <PhoneInput
                                name={`accessSupport.${index}.phoneNumber.${phIndex}.number`}
                                country={"us"} // default country
                                onChange={(value, country) => {

                                  let dialCode = country.dialCode;
                                  let onlyNumber = value.startsWith(dialCode)
                                    ? value.slice(dialCode.length)
                                    : value;

                                  onlyNumber = onlyNumber.replace(/^0+/, "");

                                  const formattedNumber = `+${country.dialCode} ${onlyNumber}`;
                                  setFieldValue(
                                    `accessSupport.${index}.phoneNumber.${phIndex}.number`,
                                    formattedNumber
                                  );
                                }}
                                inputClass="form-control  w-100  phoneInp"
                                style={{ borderColor: "#0AB7EA", minWidth: "100%" }}
                              />


                              <ErrorMessage
                                name={`accessSupport.${index}.phoneNumber.${phIndex}.number`}
                                component="div"
                                className="text-danger mt-1 position-absolute "
                              />

                            </div>


                          </div>
                        ))}
                      </div>



                      {/* Emails */}
                      <FieldArray style={{ borderColor: "#0AB7EA" }} name={`accessSupport.${index}.email`}>
                        {({ push, remove }) => (
                          <div className="mt-3">
                            <label className="form-label">Emails</label>
                            {support.email.map((em, emIndex) => (
                              <div key={emIndex} >
                                <div className="d-flex gap-2 mb-2">

                                  <Field
                                    name={`accessSupport.${index}.email.${emIndex}`}
                                    className="form-control"
                                    placeholder="Enter email"
                                    type="email"
                                    style={{ borderColor: "#0AB7EA" }}
                                  />




                                  {support.email.length > 1 && (
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={() => remove(emIndex)}
                                    >
                                      X
                                    </button>
                                  )}



                                </div>
                                <ErrorMessage
                                  name={`accessSupport.${index}.email.${emIndex}`}
                                  component="div"
                                  className="text-danger mt-1"
                                />
                              </div>
                            ))}
                            <button
                              type="button"
                              className="btn btn-secondary btn-sm"
                              onClick={() => push("")}
                            >
                              + Add Email
                            </button>
                          </div>
                        )}
                      </FieldArray>






                      <div className="mt-2">
                        <div>Location :</div>




                        <div>
                          <div className="mb-2">
                            <label className="form-label">Name</label>
                            <Field
                              name={`accessSupport.${index}.location.name`}
                              className="form-control"
                              style={{ borderColor: "#0AB7EA" }}
                            />
                            <ErrorMessage
                              name={`accessSupport.${index}.location.name`}
                              component="div"
                              className="text-danger"
                            />

                          </div>

                          <div className="row">


                            <div className="col-md-6 mb-2">
                              <label className="form-label">Street Address</label>

                              <Field name={`accessSupport.${index}.location.streetAddress`}>
                                {({ form }) => (
                                  <LocationAdd
                                    onSelect={(location) => {


                                      form.setFieldValue(`accessSupport.${index}.location.city`, location.city || "");
                                      form.setFieldValue(`accessSupport.${index}.location.state`, location.state || "");
                                      form.setFieldValue(`accessSupport.${index}.location.streetAddress`, location.name || "");
                                      form.setFieldValue(`accessSupport.${index}.location.pincode`, location.pincode || "");
                                      form.setFieldValue(`accessSupport.${index}.location.location.type`, location.location.type || "");
                                      form.setFieldValue(`accessSupport.${index}.location.location.coordinates[0]`, location.location.coordinates[0] || "");
                                      form.setFieldValue(`accessSupport.${index}.location.location.coordinates[1]`, location.location.coordinates[1] || "");
                                    }}
                                  />
                                )}
                              </Field>


                              <ErrorMessage
                                name={`accessSupport.${index}.location.streetAddress`}
                                component="div"
                                className="text-danger"
                              />
                            </div>







                            <div className="col-md-6 mb-2">
                              <label className="form-label">State</label>
                              <Field
                                name={`accessSupport.${index}.location.state`}
                                className="form-control"
                                style={{ borderColor: "#0AB7EA" }}
                              />
                              <ErrorMessage
                                name={`accessSupport.${index}.location.state`}
                                component="div"
                                className="text-danger"
                              />
                            </div>

                          </div>


                          <div className="row">

                            <div className="col-md-6 mb-2">
                              <label className="form-label">City</label>
                              <Field
                                name={`accessSupport.${index}.location.city`}
                                className="form-control"
                                style={{ borderColor: "#0AB7EA" }}
                              />
                              <ErrorMessage
                                name={`accessSupport.${index}.location.city`}
                                component="div"
                                className="text-danger"
                              />
                            </div>

                            <div className="col-md-6 mb-2">
                              <label className="form-label">Pin Code</label>
                              <Field
                                name={`accessSupport.${index}.location.pincode`}
                                className="form-control"
                                style={{ borderColor: "#0AB7EA" }}
                              />
                              <ErrorMessage
                                name={`accessSupport.${index}.location.pincode`}
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>


                        </div>

                      </div>







                    </div>
                  ))}
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() =>
                      push({
                        office: "",
                        name: "",
                        phoneNumber: [
                          { title: "Primary", number: "" },
                          { title: "Emergency", number: "" },
                        ],
                        email: [""],
                        post: "",
                        location: {
                          name: "",
                          city: "",
                          state: "",
                          streetAddress: "",
                          pincode: "",
                        },
                      })
                    }
                  >
                    + Add Access Support
                  </button>
                </div>
              )}
            </FieldArray>


            {/* FAQ Section */}
            <FieldArray name="faq">
              {({ push, remove }) => (
                <div className="mt-4">
                  <h5>FAQ</h5>
                  {values.faq.map((item, index) => (
                    <div key={index} className="border rounded p-3 mb-3 bg-light">
                      <div className="d-flex justify-content-between">
                        <h6>FAQ #{index + 1}</h6>
                        {values.faq.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => remove(index)}
                          >
                            Remove
                          </button>
                        )}
                      </div>

                      <div className="mb-2">
                        <label className="form-label">Question</label>
                        <Field
                          name={`faq.${index}.question`}
                          className="form-control"
                          style={{ borderColor: "#0AB7EA" }}
                        />
                        <ErrorMessage
                          name={`faq.${index}.question`}
                          component="div"
                          className="text-danger"
                        />
                      </div>

                      <div className="mb-2">
                        <label className="form-label">Answer</label>
                        <Field
                          as="textarea"
                          name={`faq.${index}.answer`}
                          className="form-control"
                          style={{ borderColor: "#0AB7EA" }}
                          rows={3}
                        />
                        <ErrorMessage
                          name={`faq.${index}.answer`}
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </div>
                  ))}

                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => push({ question: "", answer: "" })}
                  >
                    + Add FAQ
                  </button>
                </div>
              )}
            </FieldArray>








            {/* Submit */}
            <button
              type="submit"
              className="btn mt-4 px-4"
              style={{ backgroundColor: "#0AB7EA", color: "white" }}
              disabled={isSubmitting || uploadingLogo || uploadingBanner}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Submitting...
                </>
              ) : (
                "Submit"
              )}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default FormComponent;
